import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Documento } from '../../cliente/documento.model';
import { SnackService } from '../../shared-services/snack.service';
import { ClienteService } from '../../core/cliente.service';
import { BackendService } from '../../core/backend.service';
import { Cliente } from '../../cliente/cliente.model';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { EstadoCliente } from '../../cliente/estadoCliente.model';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Imagen } from '../imagen.model';
import { Producto } from '../producto.model';
import { ImagenService } from '../../core/imagen.service.';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '../../core/api.service';
import { Parametric } from '../../cliente/parametric.model';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-producto-imagenes-upload',
  templateUrl: './producto-imagenes-upload.component.html',
  styleUrls: ['./producto-imagenes-upload.component.scss']
})
export class ProductoImagenesUploadComponent implements OnInit {
  @Input() imagenes: Imagen[];
  @Input() estado: OperationalParametric;
  @Input() idProducto: number;
  //@Input() coloresPosibles: OperationalParametric[];
  //@Input() tiposImagenes: Observable<Parametric[]>;

  private re = /(?:\.([^.]+))?$/;
  private EstadoCliente = new EstadoCliente();
  seleccionarArchivo = 'Seleccionar imágen';

  public tiposDeImagen: String[] = ["Personalizable","No Personalizable"];

  constructor(
    private clienteService: ClienteService,
    private backendService: BackendService,
    private snackService: SnackService,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private apiService: ApiService,
    private dialogService: DialogService) { }

  ngOnInit() {
    if (this.imagenes.length === 0) {
      this.agregarImagen();
    }
    this.imagenes[0].personalizable = 'Personalizable'
    console.log(this.imagenes)
    this.imagenes.forEach(i => {
      
      if (i.path && i.path.indexOf('http') < 0) {
        this.getImages(i);
      } else {
        i.url = i.path + i.name;
      }
      if(i.esPersonalizable){
        i.personalizable='Personalizable';
      }else{
        i.personalizable='No Personalizable';
      }
      
    });
    

  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  getImages(imagen: Imagen) {
    this.clienteService.getImagenById(imagen.id).subscribe(data => {
      const urlCreator = window.URL;
      const safeUrl: any = this.sanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(data));
      imagen.url = safeUrl;
      
    });

    
  }

  agregarImagen() {
    this.imagenes.push(new Imagen(undefined));
    

  }
  eliminarImagen(index: number) {
    if (this.imagenes[index].id) {
      this.dialogService.confirm('Eliminar archivo',
      '¿Está seguro que desea eliminar la imagen ' + this.imagenes[index].path
       + '?')
      .then( res => {
        if (res) {
          this.deleteFromDb(this.imagenes[index].path);
          this.imagenes.splice(index, 1);
          if (this.imagenes.length === 0) {
            this.imagenes.push(new Imagen(undefined));
          }
        }
      });
    } else {
      this.imagenes.splice(index, 1);
    }
  }
  deleteFromDb(path: string) {
    this.backendService.update(Producto.newPath + 'eliminar-imagen/' + this.idProducto, path);
  }
  addFile(event, index: number) {
    if (this.soloImagenesOPdf(event.target.files[0].name)) {
      this.imagenes[index].file = event.target.files[0];
      this.imagenes[index].path = event.target.files[0].path;
      this.imagenes[index].name = event.target.files[0].name;
      this.imagenes[index].personalizable = 'No Personalizable';
      this.imagenes[index].id = undefined;
      this.imagenes[index].esPersonalizable = false;
    }
  }

  soloImagenesOPdf(fileName: string) {
    let ext = this.re.exec(fileName)[1];
    ext = ext.toLowerCase();
    if (ext !== 'png' && ext !== 'jpg' && ext !== 'svg' && ext !== 'jpeg' && ext !== 'gif' && ext !== 'pdf') {
      this.snackService.error('Solo estan permitidos archivos de tipo ".png", ".jpg", ".svg", ".jpeg", ".gif" o ".pdf"');
      return false;
    }
    return true;
  }


  private openWindow(img: Imagen) {
    this.dialogService.imageViewer(img.name, '', img.url);
    // window.open(img.url, '_blank');
  }

  onTipoImagenSelect(value: string, imge :Imagen){
    console.log(imge);
    console.log(value);
    imge.personalizable = value;  //this.proveedorId = this.producto.proveedor.id;
    console.log(imge.personalizable);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/productos/producto-imagenes-upload/producto-imagenes-upload.component.ts